import * as actionTypes from '../actionTypes/review';

// product review list
export function getProductReviewListLoad(payload) {
  return { type: actionTypes.GET_PRODUCT_REVIEW_LIST_LOAD, payload };
}

export function getProductReviewListSuccess(payload) {
  return { type: actionTypes.GET_PRODUCT_REVIEW_LIST_SUCCESS, payload };
}

export function getProductReviewListFail(payload) {
  return { type: actionTypes.GET_PRODUCT_REVIEW_LIST_FAIL, payload };
}

export function getProductReviewListReset(payload) {
  return { type: actionTypes.GET_PRODUCT_REVIEW_LIST_RESET, payload };
}

// post review

export function postReviewLoad(payload) {
  return { type: actionTypes.POST_REVIEW_LOAD, payload };
}

export function postReviewSuccess(payload) {
  return { type: actionTypes.POST_REVIEW_SUCCESS, payload };
}

export function postReviewFal(payload) {
  return { type: actionTypes.POST_REVIEW_FAIL, payload };
}

export function postReviewReset(payload) {
  return { type: actionTypes.POST_REVIEW_RESET, payload };
}
